import React, { useState } from 'react';

import {
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Button,
  Portal,
  VStack,
} from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';

import BulkDeleteModal from './BulkDeleteModal';

const BulkActionsMenu = ({ storeOptions = [], onCompleted }) => {
  const [modalMode, setModalMode] = useState(null);

  return (
    <>
      <Popover placement="bottom-end">
        <PopoverTrigger>
          <IconButton
            aria-label="Bulk actions"
            icon={<DeleteIcon />}
            variant="ghost"
          />
        </PopoverTrigger>
        <Portal>
          <PopoverContent w="auto">
            <PopoverBody p={2}>
              <VStack align="stretch" spacing={1}>
                <Button
                  size="sm"
                  variant="ghost"
                  justifyContent="flex-start"
                  onClick={() => setModalMode('sku-csv')}
                >
                  Bulk delete SKUs (CSV)
                </Button>
                <Button
                  size="sm"
                  variant="ghost"
                  justifyContent="flex-start"
                  onClick={() => setModalMode('listing-csv')}
                >
                  Bulk delete listings (CSV)
                </Button>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>

      <BulkDeleteModal
        isOpen={Boolean(modalMode)}
        onClose={() => setModalMode(null)}
        mode={modalMode}
        storeOptions={storeOptions}
        onCompleted={onCompleted}
      />
    </>
  );
};

export default BulkActionsMenu;
